var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right"},[_c('div',{staticClass:"title-box"},[_c('span',{staticClass:"curr"},[_vm._v("会议服务")])]),_c('div',{staticClass:"pt-30"},[_c('p',[_vm._v("邀请国内外知名经济学家、国际政要、两院院士、诺贝尔奖得主、军事专家、专家学者、部委领导分析当前国内外经济形势，解读当前国家经济相关政策，在全国范围内举办经济论坛、高峰会、行业研讨会、大型活动以及系列专题讲座。")]),_c('p',[_vm._v("通过组织论坛、专题考察、调研，搭建政府与企业，企业与企业之间的桥梁，促进政府与企业之间资源与资本的全面融合。")])])])
}]

export { render, staticRenderFns }